import type { HubProject } from '../api/data360'
import type { ProjectDetails } from '../types'

export function projectMatchesQuery(project: ProjectDetails, q: string): boolean {
  const candidates: Array<string | undefined> = [
    project.name,
    project.projectNumber,
    project.client,
    project.location,
    project.application,
    ...(project.endClients ?? []),
    ...(project.applications ?? [])
  ]
  return candidates.some((value) => !!value && value.toLowerCase().includes(q))
}

export function filterHubProjects(projects: HubProject[], query: string): HubProject[] {
  const q = query.trim().toLowerCase()
  if (!q) return projects
  return projects.filter((project) => projectMatchesQuery(project, q))
}
